import React from "react";
import { Container } from "../GodMode";
import Button from "../../Generic/Button";

const COOLING_TASKS = {
	"COOLING_ON" : "COOLING_ON",
	"COOLING_OFF" : "COOLING_OFF"
}

const COOLING_TASKS_CONFIG = {
	[COOLING_TASKS.COOLING_ON]: { 
		taskType: "cooling_on", 
		name: "Turn Cooling ON" 
	},
	[COOLING_TASKS.COOLING_OFF]: { 
		taskType: "cooling_off", 
		name: "Turn Cooling OFF" 
	},
};

const Cooling = ({ sendTask, loadingStates }) => {
	const isCoolingOnLoading = loadingStates[COOLING_TASKS_CONFIG[COOLING_TASKS.COOLING_ON].taskType] || false;
	const isCoolingOffLoading = loadingStates[COOLING_TASKS_CONFIG[COOLING_TASKS.COOLING_OFF].taskType] || false;

	const handleCoolingOn = async () => {
		await sendTask(COOLING_TASKS_CONFIG[COOLING_TASKS.COOLING_ON], {});
	};

	const handleCoolingOff = async () => {
		await sendTask(COOLING_TASKS_CONFIG[COOLING_TASKS.COOLING_OFF], {});
	};

	return (
		<Container>
			<Button onClick={handleCoolingOn} disabled={isCoolingOnLoading}>
				Cooling ON
			</Button>
			<Button onClick={handleCoolingOff} disabled={isCoolingOffLoading}>
				Cooling OFF
			</Button>
		</Container>
	);
};

export default Cooling;
